const validateWebsite = (url) => {
  const regex =
    /* eslint-disable no-useless-escape */
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g
  const isValid = regex.test(url)
  return isValid
}

export default validateWebsite
